import { useDispatch as useAppDispatch } from 'react-redux'
import { type AppDispatch } from 'services'

type DispatchFunc = () => AppDispatch
const useDispatch: DispatchFunc = useAppDispatch

export default useDispatch
